<template>
	<div class="page flex-column">
		<div class="head flex-center">
			<div v-if="sysTime" class="date">系统时间：{{sysTime.format('yyyy/MM/dd hh:mm')}}</div>
			<p>{{title}}</p>
			<div class="exit flex-center" @click="exitHandle"><i class="tf">&#xe620;</i>退出大屏</div>
		</div>
		<div class="body flex-column flex-grow">
			<div v-for="(row, i) in layout" :key="i" class="body-row flex flex-grow">
				<template v-for="(item, j) in row">
					<module-quota v-if="item.module_type == 2" :key="j" :id="item.module_id" :notice="i == 0"></module-quota>
					<module-charts v-else-if="item.module_type == 1" :key="j" :id="item.module_id" :horizontal="i == 1 || row.length == 1"></module-charts>
					<module-list v-else-if="item.module_type == 3" :key="j" :id="item.module_id"></module-list>
				</template>
			</div>
		</div>

		<c-dialog ref="digitalList" width="600" :title="false" :close-button="false" :button="false">
			<dl class="digital-list">
				<dt>请选择数据看板</dt>
				<dd>
					<ul>
						<li v-for="(item, i) in digitalList" :key="i" class="flex-center" :class="{'z-hl': digitalHlIndex == i}" @click="redirectTo(`/digital/${item.digital_id}`)">
							<i class="icon tf-nav-p_workshop"></i>
							<p class="flex-grow ellipsis">{{item.menu_name}}<span v-if="item.is_builtin">（内置）</span></p>
						</li>
					</ul>
				</dd>
			</dl>
		</c-dialog>
	</div>
</template>

<script>
	import moduleQuota from './components/digital_quota.vue'
	import moduleCharts from './components/digital_charts.vue'
	import moduleList from './components/digital_list.vue'
	import {SYS} from '@/config'
	import {createStore, mapStore, throttle} from '@deanwu/vue-component-library'

	export default {
		components: {
			moduleQuota,
			moduleCharts,
			moduleList
		},

		props: {
			id: String
		},

		data() {
			return {
				sysTime: null,
				digitalStore: createStore({
					px(n) {
						if (window.innerWidth >= 1400) {
							return n;
						} else {
							return n * Math.min(1, 0.000714796 * window.innerWidth);
						}
					},
					registerChart: obj => {
						this.charts.push(obj);
					},
					processRateScale: 1
				}),
				digitalList: [],
				digitalHlIndex: 0,
				digitalId: '',
				title: '',
				layout: [],
				charts: []
			}
		},

		computed: {
			...mapStore('digitalStore', ['px'])
		},

		watch: {
			id: {
				handler(val) {
					this.title = '';
					this.layout = [];
					this.charts = [];
					if (val) {
						this.$refs.digitalList && this.$refs.digitalList.close();
						this.update();
					} else {
						this.request({
							url: '/digital/menu',
							success: data => {
								if (data.length == 1) {
									this.redirectTo(`/digital/${data[0].digital_id}`);
									return;
								}
								this.digitalList = data;
								this.digitalHlIndex = 0;
								this.$refs.digitalList.open();
							}
						});
					}
				},
				immediate: true
			}
		},
		
		mounted() {
			this.fullHandle();
			this.digitalStore.commit('processRateScale', this.px(70) / 70);
			if (SYS == 'digital') {
				document.body.focus();
				document.addEventListener('keydown', this.tvEvent);
			}
			window.addEventListener('resize', throttle(() => {
				this.charts.forEach(item => {
					item.resize();
				});
				this.digitalStore.commit('processRateScale', this.px(70) / 70);
			}, 500));

			this._sysTimeRequest = this.request({
				url: '/timestamp',
				success: data => {
					let diff = new Date().getTime() - data;
					!function loop() {
						this.sysTime = new Date(new Date().getTime() - diff);
						this._sysTimer = setTimeout(() => {
							loop.call(this);
						}, 1000);
					}.call(this);
				}
			});
		},

		beforeDestroy() {
			if (SYS == 'digital') {
				document.removeEventListener('keydown', this.tvEvent);
			}
			this._sysTimeRequest && this._sysTimeRequest.abort();
			clearTimeout(this._sysTimer);
		},
		
		methods: {
			update() {
				this.request({
					url: '/digital/info',
					data: {
						digital_id: this.id
					},
					success: data => {
						this.digitalId = data.id;
						this.title = data.title;
						this.layout = data.config_json;
					}
				})
			},

			tvEvent(e) {
				let key = e.key || keyCode;
				if ([
					'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter', 'Escape',
					37, 38, 39, 40, 13, 27
				].includes(key)) {
					e.preventDefault();
				}
				switch(key) {
					case 'ArrowUp':
					case 38:
						if (this.digitalHlIndex > 0) {
							this.digitalHlIndex--;
						}
						break;
					case 'ArrowDown':
					case 40:
						if (this.digitalHlIndex < this.digitalList.length - 1) {
							this.digitalHlIndex++;
						}
						break;
					case 'Enter':
					case 13:
						this.redirectTo(`/digital/${this.digitalList[this.digitalHlIndex].digital_id}`);
						break;
					case 'Escape':
					case 27:
						this.redirectTo('/digital');
						break;
				}
			},

			fullHandle() {
				if (SYS == 'digital') return;
				const elem = document.documentElement;
				if (elem.requestFullscreen) {
					elem.requestFullscreen();
				} else if (elem.mozRequestFullScreen) {
					elem.mozRequestFullScreen();
				} else if (elem.webkitRequestFullscreen) {
					elem.webkitRequestFullscreen();
				} else if (elem.msRequestFullscreen) {
					elem.msRequestFullscreen();
				}
			},

			exitHandle() {
				if (SYS == 'digital') {
					this.logout();
					return;
				}
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.webkitExitFullscreen) {
					document.webkitExitFullscreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}
				this.navigateTo('/');
			},
			
			logout() {
				this.request({
					url: '/sys_user/logout',
					loading: true,
					success: () => {
						this.$store.commit('setSession', '');
						this.navigateTo('/login');
					}
				});
			}
		}
	}
</script>

<style lang="stylus">
	html {
		font-size: 100px;

		@media screen and (max-width: 1399px) {
			font-size: 7.14796vw;
		}
	}
</style>

<style lang="stylus" scoped>
	.page {
		box-sizing: border-box;
		height: 100vh;
		overflow: hidden;
		background-color: #011131;
		background-image: url('~@/assets/image/digital/bg.jpg');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		user-select: none;

		.head {
			position: relative;
			height: .72rem;
			margin-bottom: .15rem;
			background-image: url('~@/assets/image/digital/head.png');
			background-size: 100% 100%;
			background-position: center;
			background-repeat: no-repeat;
			
			&:after {
				content: '';
				position: absolute;
				left: 0;
				top: 0;
				width: .5rem;
				height: .02rem;
				background-image: url('~@/assets/image/digital/an_head.png');
				background-size: 100%;
				animation: headMove 5s infinite linear;
			
				@keyframes headMove {
					0% {
						opacity: 0;
						transform: translate(0,0);
					}
					10% {
						opacity: 1;
					}
					70% {
						opacity: 1;
					}
					80% {
						opacity: 0;
						transform: translate(100vw,0);
					}
					100% {
						opacity: 0;
						transform: translate(100vw,0);
					}
				}
			}

			.date {
				position: absolute;
				top: .14rem;
				left: .9rem;
				font-size: .16rem;
				color: #01F5C3;
			}

			p {
				padding-bottom: .05rem;
				font-size: .32rem;
				font-weight: bold;
				color: transparent;
				background: linear-gradient(to bottom, #FFFFFF, #75DAFF);
				background-clip: text;
			}

			.exit {
				position: absolute;
				top: -.03rem;
				right: .9rem;
				width: 1.2rem;
				height: .44rem;
				font-size: .14rem;
				color: #00F6C2;
				background-image: url('~@/assets/image/digital/exit.png');
				background-size: 100% 100%;
				cursor: pointer;

				.tf {
					margin-right: .08rem;
				}
			}
		}

		.body {
			padding: 0 .15rem .15rem;

			&-row {
				&:nth-child(1) {
					flex-grow: 1.375;
				}

				&:nth-child(n+2) {
					margin-top: .15rem;
				}

				.m-quota:nth-child(n+2),
				.m-charts:nth-child(n+2),
				.m-list:nth-child(n+2) {
					margin-left: .15rem;
				}
			}
		}
	}

	>>> .c-empty {
		&-icon {
			width: .8rem;
			height: .8rem;
		}

		&-message {
			margin-top: .1rem;
			font-size: .16rem;
		}
	}

	.digital-list {
		border-radius: 10px;
		padding: 0 30px 40px;
		background: #FFFFFF;

		dt {
			line-height: 100px;
			font-size: 24px;
			font-weight: bold;
			text-align: center;
		}

		dd {
			li {
				height: 60px;
				border-radius: 4px;
				padding: 0 22px;
				margin-bottom: 13px;
				color: #fff;
				background: #32373E;
				outline: none;
				cursor: pointer;

				&:hover {
					background: #0D71A1;
				}

				&.z-hl {
					background: #0D71A1;
					outline: 3px solid #00ffcc;
				}

				.icon {
					margin-right: 16px;
					font-size: 20px;
				}
			}
		}
	}
</style>
